(() => {
  const desktopPointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const galleryCache = new WeakMap();
  const requestTokens = new WeakMap();

  const readGallery = (gallery) => {
    if (galleryCache.has(gallery)) return galleryCache.get(gallery);

    const dataNode = gallery.querySelector('[data-zv-card-gallery-data]');
    let images = [];

    try {
      images = JSON.parse(dataNode?.textContent || '[]');
    } catch (error) {
      images = [];
    }

    galleryCache.set(gallery, images);
    return images;
  };

  const updateStatus = (gallery, index, total) => {
    const status = gallery.querySelector('[data-zv-card-gallery-status]');
    if (!status) return;

    const template = gallery.dataset.zvCardGalleryStatusTemplate || 'Image __current__ of __total__';
    status.textContent = template.replace('__current__', String(index + 1)).replace('__total__', String(total));
  };

  const showImage = (gallery, index) => {
    const images = readGallery(gallery);
    const imageData = images[index];
    const stage = gallery.querySelector('[data-zv-card-gallery-stage]');
    if (!imageData || !stage) return;

    let image = stage.querySelector('img');
    if (!image) {
      image = document.createElement('img');
      image.decoding = 'async';
      image.loading = 'eager';
      stage.appendChild(image);
    }

    stage.classList.add('is-changing');
    image.alt = imageData.alt || '';
    image.width = imageData.width || 1200;
    image.height = imageData.height || 1500;

    const requestToken = (requestTokens.get(gallery) || 0) + 1;
    requestTokens.set(gallery, requestToken);

    const reveal = () => {
      if (requestTokens.get(gallery) !== requestToken) return;
      stage.classList.remove('is-changing');
      gallery.classList.add('is-gallery-active');
    };

    image.addEventListener('load', reveal, { once: true });
    image.src = imageData.src;
    if (image.complete) reveal();

    gallery.dataset.zvCardGalleryIndex = String(index);
    updateStatus(gallery, index, images.length);
  };

  const resetGallery = (gallery) => {
    requestTokens.set(gallery, (requestTokens.get(gallery) || 0) + 1);
    gallery.classList.remove('is-gallery-active');
    gallery.querySelector('[data-zv-card-gallery-stage]')?.classList.remove('is-changing');
    gallery.removeAttribute('data-zv-card-gallery-index');
    const status = gallery.querySelector('[data-zv-card-gallery-status]');
    if (status) status.textContent = '';
  };

  document.addEventListener('pointerdown', (event) => {
    const button = event.target.closest('[data-zv-card-gallery-previous], [data-zv-card-gallery-next]');
    if (!button || !desktopPointer.matches) return;

    event.preventDefault();
    event.stopPropagation();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-zv-card-gallery-previous], [data-zv-card-gallery-next]');
    if (!button || !desktopPointer.matches) return;

    event.preventDefault();
    event.stopPropagation();

    const gallery = button.closest('[data-zv-card-gallery]');
    if (!gallery) return;

    const images = readGallery(gallery);
    if (images.length < 2) return;

    const currentIndex = gallery.classList.contains('is-gallery-active')
      ? Number(gallery.dataset.zvCardGalleryIndex || 0)
      : Number(gallery.dataset.zvCardGalleryHoverIndex || 0);
    const direction = button.matches('[data-zv-card-gallery-next]') ? 1 : -1;
    const nextIndex = (currentIndex + direction + images.length) % images.length;

    showImage(gallery, nextIndex);
  });

  document.addEventListener('pointerover', (event) => {
    if (!desktopPointer.matches) return;

    const gallery = event.target.closest('[data-zv-card-gallery]');
    if (!gallery || gallery.dataset.zvCardGalleryBound === 'true') return;

    gallery.dataset.zvCardGalleryBound = 'true';
    gallery.addEventListener('pointerleave', () => resetGallery(gallery));

    const images = readGallery(gallery);
    if (images.length > 2) {
      const preload = new Image();
      preload.src = images[2].src;
    }
  });
})();
